import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import MainBreadcrumbs from 'src/components/ui/MainBreadcrumbs';

const TableHeader = (props) => {
	const { crumbs } = props;
	return <Stack>{crumbs && <MainBreadcrumbs {...crumbs} />}</Stack>;
};

TableHeader.propTypes = {
	crumbs: PropTypes.shape(MainBreadcrumbs.propTypes),
};

export default TableHeader;
